import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";
import { fmtDate } from "@/components/DatePicker";

export function PrenoteReminderBanner() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/tax-impound/prenote-reminders").then((r) => setItems(r.data.items.filter((i) => i.due))).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <div className="rounded-xl border border-amber-300 bg-amber-50 p-4 flex items-start gap-3" data-testid="prenote-reminder-banner">
      <ShieldAlert className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <div className="font-semibold text-amber-900">{items.length} prenote{items.length > 1 ? "s" : ""} ready to confirm</div>
        <p className="text-xs text-amber-800 mt-0.5">Three banking days have passed since these $0 ACH prenotes were sent — check your bank for returns and confirm the result so live impounds can run.</p>
        <ul className="mt-2 flex flex-wrap gap-2">
          {items.map((i) => <li key={i.company_id} data-testid={`prenote-reminder-${i.company_id}`} className="text-xs bg-white/70 border border-amber-200 rounded-md px-2 py-1"><span className="font-medium">{i.company_name}</span> · sent {fmtDate(i.prenote_sent_at)}</li>)}
        </ul>
      </div>
      <Button size="sm" variant="outline" data-testid="prenote-reminder-go" onClick={() => navigate("/companies")}>Confirm in Clients</Button>
    </div>
  );
}
